import queryKeys from '@/constants/query-keys';
import { GetBalanceRequest, GetBalanceResponse } from '@/types/balance';
import { useQuery } from '@tanstack/react-query';
import { getAuthToken } from '@/store/auth';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { ApiResponse } from '@nf/types/api';
import { useSiteStore } from '@/store/site';
import { ApiDomain } from '@nf/types/site';

const createApiUrl = (apiDomain: ApiDomain) => {
	return `${apiDomain.ctcdDomain}/api/Customer/GetBalance`;
};

export const useAGBalance = (enableAG: boolean) => {
	const apiDomain = useSiteStore(state => state.apiDomain);
	const gameType = 'AG';
	const { data, isSuccess } = useQuery({
		queryKey: [queryKeys.GET_BALANCE],
		queryFn: () => fetchBalance({
			GameType: gameType
		}, apiDomain),
		refetchOnWindowFocus: false,
		enabled: Boolean(apiDomain.ctcdDomain) && enableAG,
	});

	return {
		AGData: data as GetBalanceResponse,
		IsAGSuccess: isSuccess
	};
}

const fetchBalance = async (getBalanceRequest: GetBalanceRequest, apiDomain: ApiDomain): Promise<ApiResponse<GetBalanceResponse>> => {
	const apiUrl = createApiUrl(apiDomain);
	const authToken = getAuthToken();
	const response = await fetchComposer.postWithBearer(apiUrl, { body: JSON.stringify(getBalanceRequest) })(authToken);
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`, { cause: response });
	}
	return await response.json();
};